// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"730":"css/reset.min","814":"css/admin.min","970":"css/main.min","992":"css/editor-style"}[chunkId] + ".css";
};